import { isValidEmailAddress } from '../functions';

$(document).ready(function () {
	// newsletter subscribe form, posts to NewslettersController@save
	$('.article-body__newsletter-subscribe').each(function () {
		var $form = $(this);
		var $email = $form.find('input[name="email"]');
		var $terms = $form.find('input[name="terms"]');
		var $button = $form.find('button[type="submit"]');
		var $response = $form.find('.article-body__newsletter-response');
		var isLoading = false;

		function showMessage(messages, type) {
			$response
				.removeClass('is-error is-success')
				.addClass(type === 'success' ? 'is-success' : 'is-error')
				.empty();
			$.each(messages, function (i, message) {
				$('<p>').text(message).appendTo($response);
			});
		}

		function clearState() {
			$response.removeClass('is-error is-success').empty();
			$email.removeClass('is-invalid');
			$terms.closest('label').removeClass('is-invalid');
		}

		$form.on('submit', function (e) {
			e.preventDefault();
			if (isLoading) { return; }

			clearState();
			var errors = [];
			var email = $.trim($email.val());

			if (email === '') {
				errors.push($form.data('msg-email-required'));
				$email.addClass('is-invalid');
			} else if (!isValidEmailAddress(email)) {
				errors.push($form.data('msg-email-invalid'));
				$email.addClass('is-invalid');
			}
			if (!$terms.is(':checked')) {
				errors.push($form.data('msg-terms'));
				$terms.closest('label').addClass('is-invalid');
			}
			if (errors.length > 0) {
				showMessage(errors, 'error');
				return;
			}

			isLoading = true;
			$button.prop('disabled', true);

			$.ajax({
				type: 'POST',
				url: baseURL + '/newsletter/save',
				data: $form.serialize(),
				dataType: 'json'
			}).done(function (response) {
				if (response.status == 1) {
					$email.val('');
					$terms.prop('checked', false);
					showMessage([response.message], 'success');
					return;
				}

				if (response.status == 0) {
					var messages = [];
					$.each(response.errors, function (field, fieldErrors) {
						if (field === 'email') { $email.addClass('is-invalid'); }
						if (field === 'terms') { $terms.closest('label').addClass('is-invalid'); }
						messages = messages.concat(fieldErrors);
					});
					showMessage(messages, 'error');
					return;
				}

				showMessage([$form.data('msg-error')], 'error');
			}).fail(function () {
				showMessage([$form.data('msg-error')], 'error');
			}).always(function () {
				isLoading = false;
				$button.prop('disabled', false);
			});
		});
	});

	$('.article-body').each(function () {
		var $section = $(this);
		var $toggle = $section.find('.article-body__sidebar-toggle');

		function toggleSidebar(open) {
			$section.toggleClass('is-sidebar-open', open);
			$toggle.attr('aria-expanded', open ? 'true' : 'false');
			$('body').css('overflow', open ? 'hidden' : '');
		}

		$toggle.on('click', function () {
			toggleSidebar(true);
		});

		$section.on('click', '[data-article-sidebar-close]', function () {
			toggleSidebar(false);
		});

		$(document).on('keydown', function (e) {
			if (e.key === 'Escape' && $section.hasClass('is-sidebar-open')) {
				toggleSidebar(false);
			}
		});

		// the panel only exists below 1024px, so close it when the viewport grows past that
		$(window).on('resize', function () {
			if (window.innerWidth > 1023 && $section.hasClass('is-sidebar-open')) {
				toggleSidebar(false);
			}
		});
	});
});



// WEBPACK FOOTER //
// ./resources/js/modules/article-body.js